import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconDiamond({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<path
				fill="#CD0400"
				d="M23.2 21.2c-.8-3.3-2-6.5-3.6-9.5v-.1c-3.4-6.4-7.3-9.7-7.3-9.7q-.15-.15-.3 0s-3.9 3.3-7.3 9.7v.1c-1.6 3-2.8 6.2-3.6 9.4v.1l.1.1v-.1.1s5 1.3 11 1.3c5.9 0 10.9-1.3 11-1.3l.1-.1c-.1.1-.1.1-.1 0"
			/>
			<g fill="#FFF">
				<path d="M1.3 6c-.1 0-.2-.1-.3-.1-.1-.2-.1-.4 0-.5l2.2-2.2c.2-.2.4-.2.5 0 .1.1.1.3 0 .5L1.5 5.9c-.1 0-.1.1-.2.1" />
				<path d="M3.5 6c-.1 0-.2 0-.2-.1L1 3.6c-.1-.1-.1-.3 0-.4.2-.2.4-.2.5 0l2.2 2.2c.1.1.1.3 0 .5 0 0-.1.1-.2.1" />
			</g>
			<g fill="#FFF">
				<path d="M22.8 17.5h-.1c-.1-.1-.1-.2 0-.2l1.1-1.1c.1-.1.2-.1.2 0 .1.1.1.2 0 .2l-1.1 1.1z" />
				<path d="M23.8 17.5h-.1l-1.1-1.1c-.1-.1-.1-.2 0-.2.1-.1.2-.1.2 0l1.1 1.1c.1.1.1.2 0 .2z" />
			</g>
			<g fill="#FFF">
				<path d="M15.7 2.7h-.1c-.1-.1-.1-.2 0-.2l1.1-1.1c.1-.1.2-.1.2 0 .1.1.1.2 0 .2l-1.1 1.1z" />
				<path d="M16.8 2.7h-.1l-1.1-1.1c-.1-.1-.1-.2 0-.2.1-.1.2-.1.2 0l1.1 1.1c.1.1.1.2 0 .2z" />
			</g>
			<path
				fill="#CD0400"
				d="M22.2 20.6c-.8-3.3-2-6.5-3.6-9.5V11c-3.4-6.4-7.3-9.7-7.3-9.7q-.15-.15-.3 0S7.1 4.6 3.7 11v.1c-1.6 3-2.8 6.2-3.6 9.4v.1l.1.1v-.1.1s5 1.3 11 1.3c5.9 0 10.9-1.3 11-1.3l.1-.1c-.1.1-.1.1-.1 0"
			/>
			<path
				fill="#FFF"
				d="M4.4 20.3c-.1.4-.1.7-.1.9-1.1-.2-2.1-.4-2.8-.5.8-.1 1.8-.3 2.9-.4"
			/>
			<path
				fill="#CD0400"
				d="M22.2 20.6c-.8-3.3-2-6.5-3.6-9.5V11c-3.4-6.4-7.3-9.7-7.3-9.7q-.15-.15-.3 0S7.1 4.6 3.7 11v.1c-1.6 3-2.8 6.2-3.6 9.4v.1l.1.1v-.1.1s5 1.3 11 1.3c5.9 0 10.9-1.3 11-1.3l.1-.1c-.1.1-.1.1-.1 0 0 .1 0 0 0 0"
			/>
			<path
				fill="#FFF"
				d="M4.4 20.3c-.1.4-.1.7-.1.9-1.1-.2-2.1-.4-2.8-.5.8-.1 1.8-.2 2.9-.4m10.9-.3c-.8.4-2.5 1.3-4.2 1.6-1.7-.3-3.3-1.1-4.1-1.6 1.3-.2 2.7-.4 4.2-.5 1.4.2 2.8.3 4.1.5M5.5 8.9C6.2 7.7 7 6.5 7.9 5.4c.1.1.3.3.6.4-.2.4-.3.7-.5 1-.2.1-1.2.8-2.5 2.1m2.6-3.8c.6-.8 1.2-1.4 1.7-1.9-.4.7-.8 1.4-1.2 2.2-.2-.1-.3-.2-.5-.3m3 2c-.6-.5-1.3-1-1.9-1.4.6-1.2 1.2-2.4 1.9-3.5.7 1.1 1.3 2.2 1.9 3.5-.6.4-1.3.9-1.9 1.4m-1.6 12c-1.6.2-3 .4-4.3.6l.3-1.5c1.1.4 2.5.7 4 .9m-6.4-2.2c.9-1.2 1.8-2.4 2.7-3.5-.4 1.3-.7 2.7-.9 4.1-.7-.2-1.2-.4-1.8-.6m4.1-5.8C7.7 9.4 8.3 7.7 9 6.2c.7.5 1.3.9 1.7 1.3-.5.4-1.8 1.6-3.5 3.6m9.7 7.2.3 1.5c-1.3-.2-2.7-.4-4.3-.6 1.4-.3 2.8-.6 4-.9M11.6 7.5c.4-.3 1-.8 1.7-1.3.7 1.5 1.3 3.1 1.8 4.9-1.8-1.9-3.1-3.2-3.5-3.6m5.1 10.1c-1.7.5-3.6.9-5.6 1.1-2-.3-3.9-.7-5.6-1.1.3-1.8.8-3.5 1.2-5.2 2.2-2.6 3.8-4.1 4.4-4.5.5.5 2.2 2 4.4 4.5.5 1.7.9 3.5 1.2 5.2m-.5 2.5 1 .1c.1.5.1.8.1 1-1.5.2-2.9.3-4.3.4 1.6-.6 2.9-1.3 3.2-1.5M4 11.3c1.5-2 2.9-3.1 3.7-3.7-.6 1.4-1.1 3-1.6 4.6-.8 1-1.7 2-2.5 3.1.1-1.9.4-3.6.4-4m-.7 4.5c-.2.3-.5.6-.7.9-.3-.1-.6-.3-.8-.3.4-1.2 1-2.5 1.5-3.6 0 .8-.1 1.9 0 3m1.5 2.3c-.1.6-.2 1.2-.3 1.7-1.7.2-3.1.4-3.8.5.6-1 1.3-2 2-2.9.6.2 1.3.5 2.1.7m.2 2.2 1-.1c.3.2 1.6.9 3.1 1.5-1.4-.1-2.8-.2-4.2-.4 0-.2.1-.6.1-1M.9 19.2c.2-.7.4-1.5.7-2.2.2 0 .4.1.7.2-.5.7-.9 1.3-1.4 2m19.8 1.5c-.7.1-1.6.3-2.8.5 0-.2-.1-.5-.1-.9 1.2.2 2.2.3 2.9.4M14.2 6.8c-.1-.3-.3-.6-.4-1 .3-.2.5-.3.6-.4.9 1.1 1.7 2.3 2.4 3.5-1.3-1.3-2.3-2-2.6-2.1m-.6-1.4c-.4-.8-.8-1.5-1.2-2.3.5.5 1 1.1 1.7 1.9-.1.2-.3.3-.5.4m3.7 12.1c-.3-1.4-.6-2.8-.9-4.1.9 1.1 1.8 2.3 2.7 3.5q-.75.3-1.8.6m1.2-2.2c-.8-1.1-1.7-2.1-2.5-3.1-.5-1.6-1-3.1-1.6-4.6.8.6 2.2 1.7 3.7 3.7.2.4.5 2.1.4 4m.4-2.5q.9 1.8 1.5 3.6c-.2.1-.4.2-.8.3-.2-.3-.4-.6-.7-.9.1-1.1.1-2.2 0-3m.6 4.6c.7 1 1.4 1.9 2 2.9-.7-.1-2.1-.3-3.8-.5-.1-.5-.2-1.1-.3-1.7.8-.2 1.5-.5 2.1-.7m.5-.2q.45-.15.6-.3c.3.7.5 1.5.7 2.2-.4-.6-.9-1.2-1.3-1.9"
			/>
		</svg>
	);
}
